import type { ColumnsType } from 'antd/es/table';
import {
  EditOutlined,
  HistoryOutlined,
} from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';
import type { UserData } from './userColumns';

const roleSortWeight: Record<string, number> = {
  'ADMIN_MAIN': 1,
  'ADVISOR': 2,
  'SPECIAL': 3,
  'REGULAR': 4,
  'GENERAL': 5,
  'STUDENT': 6,
  'OTHER': 7,
};

export const getUserColumnsWithActions = (
  { onEdit, onViewLogs }: {
    onEdit: (user: UserData) => void;
    onViewLogs: (user: UserData) => void;
  }
): ColumnsType<UserData> => [
  {
    title: 'id',
    dataIndex: 'userId',
    key: 'userId',
    hidden: true,
  },
  {
    title: 'ID',
    dataIndex: 'username',
    key: 'username',
    width: 130,
    fixed: 'left',
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 100,
    fixed: 'left',
  },
  {
    title: 'Role',
    dataIndex: 'role',
    key: 'role',
    width: 90,
    defaultSortOrder: 'ascend',
    sorter: (a, b) => {
      const weightA = roleSortWeight[a.role] || 99;
      const weightB = roleSortWeight[b.role] || 99;
      return weightA - weightB;
    },
    render: (role: string) => {
      if (role === 'ADMIN_MAIN') return '관리자';
      if (role === 'ADVISOR') return '자문위원';
      if (role === 'REGULAR') return '정회원';
      if (role === 'STUDENT') return '학생회원';
      if (role === 'SPECIAL') return '특별회원';
      if (role === 'GENERAL') return '일반회원';
      if (role === 'OTHER') return '기타회원';
      return role;
    },
  },
  {
    title: '소속',
    dataIndex: 'workplace',
    key: 'workplace',
    width: 160,
    ellipsis: { showTitle: false },
    render: (v: string) =>
      v ? <Tooltip title={v}>{v}</Tooltip> : <span style={{ color: '#bbb' }}>-</span>,
  },
  {
    title: '소속과',
    dataIndex: 'department',
    key: 'department',
    width: 110,
    ellipsis: { showTitle: false },
    render: (v: string | null) =>
      v ? <Tooltip title={v}>{v}</Tooltip> : <span style={{ color: '#bbb' }}>-</span>,
  },
  {
    title: '직위',
    dataIndex: 'position',
    key: 'position',
    width: 100,
    ellipsis: { showTitle: false },
    render: (v: string | null) =>
      v ? <Tooltip title={v}>{v}</Tooltip> : <span style={{ color: '#bbb' }}>-</span>,
  },
  {
    title: '이메일',
    dataIndex: 'email',
    key: 'email',
    width: 180,
    ellipsis: { showTitle: false },
    render: (v: string) =>
      v ? <Tooltip title={v}>{v}</Tooltip> : <span style={{ color: '#bbb' }}>-</span>,
  },
  {
    title: '면허번호',
    dataIndex: 'medicalLicenseNumber',
    key: 'medicalLicenseNumber',
    width: 90,
    render: (v: string | null) =>
      v ? v : <span style={{ color: '#bbb' }}>없음</span>,
  },
  {
    title: '전문의번호',
    dataIndex: 'specialistNumber',
    key: 'specialistNumber',
    width: 90,
    render: (v: string | null, record) =>
      v ? v : <span style={{ color: '#bbb' }}>{record.isSpecialist === false ? '아니오' : '없음'}</span>,
  },
  {
    title: '휴대폰',
    dataIndex: 'phone',
    key: 'phone',
    width: 110,
    render: (v: string) => v || <span style={{ color: '#bbb' }}>-</span>,
  },
  {
    title: '가입일',
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 120,
    render: (dateString: string) => new Date(dateString).toLocaleDateString(),
  },
  {
    title: '활동',
    key: 'logs',
    align: 'center',
    width: 160,
    render: (_, record) => (
      !record.isWithdrawnYN && (
        <Space>
          <Button
            type="link"
            icon={<HistoryOutlined />}
            onClick={() => onViewLogs(record)}
            style={{ padding: 4 }}
          >
            조회 이력
          </Button>
        </Space>
      )
    ),
  },
  {
    title: '',
    key: 'edit',
    align: 'center',
    width: 90,
    fixed: 'right',
    render: (_, record) => (
      !record.isWithdrawnYN && (
        <Button
          type="link"
          icon={<EditOutlined />}
          onClick={() => onEdit(record)}
        >
          Edit
        </Button>
      )
    ),
  },
];